Vendd.Scripts.load(function () {

    var $boxes = $('.x-product-box-gtl-related');

    var $allToCartCont = $('.x-all-to-cart'), totalPrice = 0, numOfSelected = 0;

    $.each($boxes, function (i, el) {
        var $wrapper = $(this),
            wrapper;
        var model = null;

        if ($wrapper.length < 1)
            return;

        wrapper = $wrapper.get(0);

        if ($('.product-json-generator', $wrapper).length > 0) {
            var skuJsonHtml = $('.product-json-generator', $wrapper).html();
            $('.product-json-generator', $wrapper).remove();
            skuJsonHtml = skuJsonHtml.replace(/("[^"]*")|\s/g, "$1").replace(/,}/g, '}').replace(/,]/g, ']');
            var skuJson = JSON.parse(skuJsonHtml);

            var $control = $('.x-product-details-quantity-selector', $wrapper);

            $.each($control, function (i, control) {
                var $item = $(control);

                $item.on('change', '.js-selector', function (e) {

                    var $this = $(this);

                    var qty = $this.val();

                });
            });

            var $control = $('.x-product-details-version-selector', $wrapper);

            $.each($control, function (i, control) {
                var $item = $(control);

                $item.on('change', '.js-selector', function (e) {

                    var $this = $(this);

                    var qty = $this.val();

                    if ($item.hasClass("colorlist")) {
                        wrapper.updateSizes();
                        var sizelist = $('.x-product-details-version-selector.sizelist select', $wrapper);
                        if (qty > 0)
                            sizelist.removeAttr('disabled');
                        else
                            sizelist.attr('disabled', 'true');
                    }
                    selectedSku = getSKU(skuJson, $('.colorlist .js-selector', $wrapper).val(), $('.sizelist .js-selector', $wrapper).val());
                    wrapper.updateProductInfo();
                    wrapper.updateQuantity();
                });
            });

            wrapper.updateColors = function () {
                var hasSelectedValueChange = false;
                var allSizes = getColors(skuJson, $('.sizelist .js-selector', $wrapper).val());
                var $colorWrapper = $('.x-product-details-version-selector.colorlist', $wrapper);
                $.each($('option[data-set-value-id!=0]', $colorWrapper), function () {
                    var $option = $(this);
                    var sizeId = $option.data("set-value-id").toString();
                    var isEnable = _.findWhere(allSizes, sizeId) != undefined;
                    if (isEnable) {
                        $option.removeClass('disabled').show();
                    }
                    else {
                        if (sizeId == $('.js-selector', $colorWrapper).val()) hasSelectedValueChange = true;
                        $option.addClass('disabled').hide();
                    }
                });
                if (hasSelectedValueChange) {
                    $("option", $colorWrapper).attr('selected', null);
                    $("option:not(.disabled)", $colorWrapper).first().attr('selected', 'selected');
                    $colorWrapper.val($("option:not(.disabled)", $colorWrapper).first().val());
                }
            }

            wrapper.updateSizes = function () {
                var hasSelectedValueChange = false;
                var allColors = getSizes(skuJson, $('.colorlist .js-selector', $wrapper).val());
                var $sizeWrapper = $('.x-product-details-version-selector.sizelist', $wrapper);
                $.each($('option[data-set-value-id!=0]', $sizeWrapper), function () {
                    var $option = $(this);
                    var colorId = $option.data("set-value-id").toString();
                    var isEnable = _.findWhere(allColors, colorId) != undefined;
                    if (isEnable) {
                        $option.removeClass('disabled').show();
                    }
                    else {
                        if (colorId == $('.js-selector', $sizeWrapper).val()) hasSelectedValueChange = true;
                        $option.addClass('disabled').hide();
                    }
                });
                if (hasSelectedValueChange) {
                    $("option", $sizeWrapper).attr('selected', null);
                    $("option:not(.disabled)", $sizeWrapper).first().attr('selected', 'selected');
                    $sizeWrapper.val($("option:not(.disabled)", $sizeWrapper).first().val());
                }
            }

            $wrapper.off('click', '.js-add-to-cart').on('click', '.js-add-to-cart', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this);

                if ($this.hasClass('disabled') || $this.is(':disabled'))
                    return;
                if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening'))
                    return;

                var id = $wrapper.data("productid"),
                    skuId = $wrapper.data("variantid"),
                    path = $wrapper.data("path"),
                    qty = $('.qty-select.js-selector', $wrapper).val();

                var itemInfo = {
                    minQuantity: $wrapper.data("min-quantity"),
                    maxQuantity: $wrapper.data("max-quantity"),
                    quanta: $wrapper.data("quanta")
                };

                //enhanced info
                var color = $('select [data-is-color="true"].selected', $wrapper).text();
                var size = $('select [data-is-color="false"].selected', $wrapper).text();
                var list = $('ul.related-list').data('list');

                var enhancedInfo = { color: color, size: size, list: list };
                //enhanced info

                if (qty < 1) return;

                Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, '', null, null, itemInfo, enhancedInfo));                
                //Open the widget only for template 1 of Cart Widget
                if ($('.x-cart-widget').data('template') === 1) {
                    Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
                }
            });

            wrapper.loading = function (loading) {
                if (loading) {
                    $wrapper.addClass('x-loading');
                } else {
                    $wrapper.removeClass('x-loading');
                };
            };

            wrapper.updateProductInfo = function () {
                var selectedColor = $('.colorlist .js-selector', $wrapper).val();
                if (selectedColor != "0") {
                    var imgSrc = getImageColor(skuJson, selectedColor);
                    if (imgSrc != null) $('.image-container img', $wrapper).attr("src", imgSrc);
                }

                if (selectedSku == undefined) {
                    $('button.js-add-to-cart', $wrapper).addClass("disabled").attr("disabled", "disabled");
                    if ($wrapper.hasClass('js-can-add-to-cart')) {
                        $wrapper.removeClass('js-can-add-to-cart');
                        numOfSelected -= 1;
                        if (numOfSelected <= 0) {
                            $('.js-add-all-to-cart', $allToCartCont).addClass("disabled").attr("disabled", "disabled");
                            $allToCartCont.addClass('none-selected');
                            totalPrice = 0;
                        } else {
                            totalPrice -= parseFloat(stringToNumber($wrapper.data('price')));
                        }
                    }
                    $('.js-num-of-selected', $allToCartCont).text(numOfSelected);
                    $('.js-total-price', $allToCartCont).text(String(totalPrice.toFixed(2)).replace(".", ","));
                    return;
                }
                $wrapper.data("variantid", selectedSku.SkuId);

                if (selectedSku.CanBuy.toLowerCase() == "true") {
                    $('button.js-add-to-cart', $wrapper).removeClass("disabled").attr("disabled", null);
                    if(!$wrapper.hasClass('js-can-add-to-cart')){
                        $wrapper.addClass('js-can-add-to-cart');
                        numOfSelected += 1;
                        totalPrice += parseFloat(stringToNumber($wrapper.data('price')));
                        $allToCartCont.removeClass('none-selected');
                        $('.js-add-all-to-cart', $allToCartCont).removeClass("disabled").attr("disabled", null);
                    }
                } else {
                    $('button.js-add-to-cart', $wrapper).addClass("disabled").attr("disabled", "disabled");
                    if ($wrapper.hasClass('js-can-add-to-cart')) {
                        $wrapper.removeClass('js-can-add-to-cart');
                        numOfSelected -= 1;
                        if (numOfSelected <= 0) {
                            $('.js-add-all-to-cart', $allToCartCont).addClass("disabled").attr("disabled", "disabled");
                            $allToCartCont.addClass('none-selected');
                            totalPrice = 0;
                        } else {
                            totalPrice -= parseFloat(stringToNumber($wrapper.data('price')));
                        }
                    }
                }

                $('.js-num-of-selected', $allToCartCont).text(numOfSelected);
                $('.js-total-price', $allToCartCont).text(String(totalPrice.toFixed(2)).replace(".", ","));

                var model = {};
                model.Price = {};
                model.Availability = {};
                model.Price.CurrentPrice = selectedSku.UnitPrice;
                model.Price.CurrentPriceText = selectedSku.UnitPriceText;
                model.Price.DeletedPrice = selectedSku.DeletedPrice != "" ? selectedSku.DeletedPrice : null;
                model.Price.DeletedPriceText = selectedSku.DeletedPrice != "" ? selectedSku.DeletedPriceText : null;
                model.Availability.AvailabilityActionId = selectedSku.AvailabilityActionId
                model.Availability.AvailabilityName = selectedSku.AvailabilityName

                var html = Vendd.Handlebars.parse("getTheLookPrices_A", model);
                $('.prices-container', $wrapper).html(html);

            }

            wrapper.updateQuantity = function () {
                var html = "<select class='qty-select styled-select js-selector' disabled='disabled'><option value='1' selected='selected'>1</option></select>";
                if (selectedSku == undefined) {
                    
                    $('.x-product-details-quantity-selector', $wrapper).html(html);
                    $('.x-product-details-quantity-selector', $wrapper).addClass('disabled').find('select').prop('disabled', true);
                    return;
                }
                var model = {};
                if (selectedSku.CanBuy.toLowerCase() == "true") {
                    var stock = 10;
                    var stockMaxValue = parseFloat(selectedSku.StockMaxValue);
                    var minQuantity = selectedSku.MinQuantity != "" ? parseFloat(selectedSku.MinQuantity) : 1;
                    var maxQuantity = selectedSku.MaxQuantity != "" ? parseFloat(selectedSku.MaxQuantity) : stock;
                    maxQuantity = Math.max(maxQuantity, stockMaxValue);
                    maxQuantity = Math.min(maxQuantity, stock);
                    var quanta = selectedSku.Quanta != "" ? parseFloat(selectedSku.Quanta) : 1;
                    var index = 1;
                    var quantity = minQuantity * quanta;
                    var selectedValue = $('.qty-select.js-selector', $wrapper).length > 0 ? $('.qty-select.js-selector', $wrapper).val() : quantity;
                    selectedValue = selectedValue <= maxQuantity ? selectedValue : quantity;
                    do {
                        model[index] = { "Value": quantity, "Selected": quantity == selectedValue }
                        quantity = quantity + quanta;
                        index++;
                    } while (quantity <= maxQuantity && index <= 10);
                    html = Vendd.Handlebars.parse("pdQuantitySelector_A", model);
                }
                $('.x-product-details-quantity-selector', $wrapper).html(html);
            }

            wrapper.updateSizes();
            var selectedSku = getSKU(skuJson, $('.colorlist .js-selector', $wrapper).val(), $('.sizelist .js-selector', $wrapper).val());
            wrapper.updateProductInfo();
            wrapper.updateQuantity();
            if (selectedSku && selectedSku.color == "0") $('.colorlist .js-selector', $wrapper).hide();
            if (selectedSku && selectedSku.size == "0") $('.sizelist .js-selector', $wrapper).hide();
        }
    });

    function gtlSlider() {

        var $wrapper = $('.get-the-look-details-page');

        var $list = $('.js-related-products > ul', $wrapper);

        $list.on('init', function () {
            $('.gtl-item', $list).removeClass('last-visible');
            $('.gtl-item.slick-active', $list).eq($('.gtl-item.slick-active').length - 1).addClass('last-visible');
        });
        $list.on('afterChange', function () {
            $('.gtl-item', $list).removeClass('last-visible');
            $('.gtl-item.slick-active', $list).eq($('.gtl-item.slick-active').length - 1).addClass('last-visible');
        });
        $list.on('swipe', function () {
            $('.gtl-item', $list).removeClass('last-visible');
            $('.gtl-item.slick-active', $list).eq($('.gtl-item.slick-active').length - 1).addClass('last-visible');
        });

        updateListSlick($list);

        var resizeEvent;
        $(window).resize(function () {
            clearTimeout(resizeEvent);
            resizeEvent = setTimeout(function () {
                updateListSlick($list);
            }, 300);
        });
    }

    function updateListSlick(list) {
        var carouselCartOpts = {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            prevArrow: $('.js-related-products .nav-prev'),
            nextArrow: $('.js-related-products .nav-next')
        };
        if (list.children().length > 3) {
            list.slick(carouselCartOpts);
            list.siblings('.nav').show();
            list.addClass('js-slick-initialised');
        }
    }

    function getSKU(skuJson, color,size) {
        return _.first(_.filter(skuJson.skus, function (sku) { return sku.color == color && sku.size == size; }));
    }

    function getSizes(skuJson, color) {
        var allSizes=(_.filter(skuJson.skus, function (sku) { return sku.color == color }));
        return _.map(allSizes,function(obj) {return obj.size;});
    }

    function getColors(skuJson, size) {
        var allColors = (_.filter(skuJson.skus, function (sku) { return sku.size == size }));
        return _.map(allColors, function (obj) { return obj.color; });
    }

    function getImageColor(skuJson, color) {
        if (skuJson.ColorDimensions[color] == undefined) return null;
        if (skuJson.ColorDimensions[color][0] == undefined) return null;
        return skuJson.ColorDimensions[color][0]['List'];
    }

    var currency = decodeEntities(LhApp.Context.Currency.Symbol);

    $('.currency-symbol', $allToCartCont).text(currency);

    $('.js-add-all-to-cart', $allToCartCont).click(function () {

        if ($(this).hasClass('disabled') || $(this).is(':disabled'))
            return;

        var dataArray = [];

        $.each($boxes, function (i, el) {
            var $wrapper = $(this);
            if ($wrapper.hasClass('js-can-add-to-cart')) { 
                var data = {};
            
                var id = $wrapper.data("productid"),
                skuId = $wrapper.data("variantid"),
                path = $wrapper.data("path"),
                qty = $('.qty-select.js-selector', $wrapper).val();

                var data = {
                    id: id,
                    skuId: skuId,
                    path: path,
                    qty: qty
                };

                dataArray.push(data);
            }
        });
        Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Cart.Messages.MultipleAdd(dataArray));
        //Open the widget only for template 1 of Cart Widget
        if ($('.x-cart-widget').data('template') === 1) {
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
        }
    });

    $('.js-related-products').removeClass('x-loading');

});
